import { render, staticRenderFns } from "./VuePlaces.vue?vue&type=template&id=5f3df618&scoped=true&"
import script from "./VuePlaces.vue?vue&type=script&lang=js&"
export * from "./VuePlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3df618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
